import React, { useEffect, useMemo, useState } from "react";

import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row
} from "../../components/Component";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import TimekeepingConvertHourToDay from "../../components/employee/TimekeepingConvertHourToDay";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { SHIFT, TIME_KEEPING_LEAVE_TYPE, weekDayNames } from "../../utils/Utils";

const TimeKeepingScheduling = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [data, setData] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    monthYear: searchParams.get("monthYear") || moment().format("YYYY-MM"),
  });

  const colTable = useMemo(() => {
    const temp = [
      {
        Header: "Nhân viên",
        accessor: (item, index) => `${index + 1} - ${item.name}`,
        sticky: "left",
      },
      {
        Header: "Tổng(giờ)",
        className: 'text-right',
        accessor: (item) => (
          <div className={`text-in-one-line`}>
            <NumericFormat
              displayType={"text"}
              value={item.monthHour || 0}
              thousandsGroupStyle="thousand"
              thousandSeparator=","
              decimalScale={2}
            />
          </div>
        ),
      },
      {
        Header: "Ngày giờ làm",
        className: 'text-right',
        accessor: (item) => (
          <div className={`text-in-one-line`}>
            <TimekeepingConvertHourToDay hour={item.monthWorkingHour || 0} />

          </div>
        ),
      },
      {
        Header: "Giờ làm thêm(giờ)",
        className: 'text-right',
        accessor: (item) => (
          <div className={`text-in-one-line`}>
            <NumericFormat
              displayType={"text"}
              value={item.monthExtraHour || 0}
              thousandsGroupStyle="thousand"
              thousandSeparator=","
              decimalScale={2}
            />
          </div>
        ),
      },
      {
        Header: "Giờ thưởng thêm(giờ)",
        className: 'text-right',
        accessor: (item) => (
          <div className={`text-in-one-line`}>
            <NumericFormat
              displayType={"text"}
              value={(item.monthHour - item.monthWorkingHour - item.monthExtraHour) || 0}
              thousandsGroupStyle="thousand"
              thousandSeparator=","
              decimalScale={2}
            />
          </div>
        ),
      },
      {
        Header: "Giờ nghỉ(giờ)",
        className: 'text-right',
        accessor: (item) => (
          <div className={`text-in-one-line`}>
            <NumericFormat
              displayType={"text"}
              value={item.monthLeaveHour || 0}
              thousandsGroupStyle="thousand"
              thousandSeparator=","
              decimalScale={2}
            />
          </div>
        ),
      },
    ];

    const startDate = moment(filter.monthYear, "YYYY-MM").startOf("months");
    const endDate = moment(filter.monthYear, "YYYY-MM").endOf("months");

    for (let i = 0; i < endDate.date(); i++) {
      const mmTempDate = startDate.clone().add(i, "days");
      temp.push({
        Header: `${mmTempDate.format("DD")}(${weekDayNames[mmTempDate.day()]})`,
        accessor: (item) => (
          <div className={`divider-between-items p-1`}>
            {Object.values(
              item.date[mmTempDate.format("YYYY-MM-DD")] || {}
            ).map((shift) => (
              <div
                className="cursor-pointer"
                onClick={() => {
                  const newParams = new URLSearchParams({
                    startDate: moment(shift.date).startOf("days").toDate(),
                    endDate: moment(shift.date).endOf("days").toDate(),
                    employeeId: shift.employeeId,
                    shift: shift.shift,
                  });
                  history.push({
                    pathname: "/time-keeping",
                    search: newParams.toString(),
                  });
                }}
              >
                <Row>
                  <Col sm={12}>Ca {SHIFT[shift.shift]}</Col>
                  {shift.leaveType ? (
                    <Col sm={12} className={`text-in-one-line`}>
                      {TIME_KEEPING_LEAVE_TYPE[shift.leaveType]}
                    </Col>
                  ) : (
                    <Col sm={12} className={`text-in-one-line`}>
                      {shift.workingHour} giờ + {shift.extraHour} giờ
                    </Col>
                  )}
                </Row>
              </div>
            ))}
          </div>
        ),
      });
    }
    return temp;
  }, [filter.monthYear]);

  useEffect(() => {
    const { monthYear } = filter;

    const newParams = new URLSearchParams({
      monthYear,
    });

    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    GET(
      "employee/keepingtime/scheduling-by-company",
      {
        monthYear,
      },
      true
    ).then((resp) => {
      const { data: { rows } } = resp;
      setData(rows);
    });
  }, [filter]);

  const exportExcel = () => {
    const { monthYear } = filter;

    const params = new URLSearchParams({
      monthYear,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/employee/keepingtime/scheduling-by-company-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Bảng chấm công"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Bảng chấm công</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>

                    <li className="">
                      <div className="">
                        <Button
                          className=""
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default TimeKeepingScheduling;
